const DarkThemeColors = [
  {
    name: 'CRIMSON_RED',
    palette: {
      primary: {
        50: '#330000', // primary.b10
        100: '#4D0000', // primary.b8
        200: '#660000', // primary.b6
        300: '#990000', // primary.b4
        400: '#CC0000', // primary.b2
        500: '#FF0000', // primary
        600: '#FF3333', // primary.w2
        700: '#FF8080', // primary.w5
        800: '#FFCCCC', // primary.w8
        900: '#FFF2F2', // primary.w10
        main: '#FF4D4D', // primary.w3
        light: '#330000', // primary.b10
        dark: '#FFE6E6', // primary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
      secondary: {
        50: '#071627', // secondary.b10
        100: '#0B213B', // secondary.b8
        200: '#0E2C4E', // secondary.b6
        300: '#154275', // secondary.b4
        400: '#1C589C', // secondary.b2
        500: '#236EC3', // secondary
        600: '#4F8BCF', // secondary.w2
        700: '#91B7E1', // secondary.w5
        800: '#D3E2F3', // secondary.w8
        900: '#F4F8FC', // secondary.w10
        main: '#659AD5', // secondary.w3
        light: '#071627', // secondary.b10
        dark: '#E9F1F9', // secondary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
    },
  },
  {
    name: 'CELTIC_BLUE',
    palette: {
      primary: {
        50: '#071627', // secondary.b10
        100: '#0B213B', // secondary.b8
        200: '#0E2C4E', // secondary.b6
        300: '#154275', // secondary.b4
        400: '#1C589C', // secondary.b2
        500: '#236EC3', // secondary
        600: '#4F8BCF', // secondary.w2
        700: '#91B7E1', // secondary.w5
        800: '#D3E2F3', // secondary.w8
        900: '#F4F8FC', // secondary.w10
        main: '#659AD5', // secondary.w3
        light: '#071627', // secondary.b10
        dark: '#E9F1F9', // secondary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
      secondary: {
        50: '#330000', // primary.b10
        100: '#4D0000', // primary.b8
        200: '#660000', // primary.b6
        300: '#990000', // primary.b4
        400: '#CC0000', // primary.b2
        500: '#FF0000', // primary
        600: '#FF3333', // primary.w2
        700: '#FF8080', // primary.w5
        800: '#FFCCCC', // primary.w8
        900: '#FFF2F2', // primary.w10
        main: '#FF4D4D', // primary.w3
        light: '#330000', // primary.b10
        dark: '#FFE6E6', // primary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
    },
  },
  {
    name: 'PIGMENT_GREEN',
    palette: {
      primary: {
        50: '#01200A', // tertiary.b10
        100: '#01300F', // tertiary.b8
        200: '#014014', // tertiary.b6
        300: '#02601E', // tertiary.b4
        400: '#028028', // tertiary.b2
        500: '#03A032', // tertiary
        600: '#35B35B', // tertiary.w2
        700: '#81D099', // tertiary.w5
        800: '#CDECD6', // tertiary.w8
        900: '#F2FAF5', // tertiary.w10
        main: '#4FBD70', // tertiary.w3
        light: '#01200A', // tertiary.b10
        dark: '#E6F6EB', // tertiary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
      secondary: {
        50: '#330000', // primary.b10
        100: '#4D0000', // primary.b8
        200: '#660000', // primary.b6
        300: '#990000', // primary.b4
        400: '#CC0000', // primary.b2
        500: '#FF0000', // primary
        600: '#FF3333', // primary.w2
        700: '#FF8080', // primary.w5
        800: '#FFCCCC', // primary.w8
        900: '#FFF2F2', // primary.w10
        main: '#FF4D4D', // primary.w3
        light: '#330000', // primary.b10
        dark: '#FFE6E6', // primary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
    },
  },
  /*
  {
    name: 'CRIMSON_RED_STANDARD',
    palette: {
      primary: {
        50: '#330000', // primary.b10
        100: '#4D0000', // primary.b8
        200: '#660000', // primary.b6
        300: '#990000', // primary.b4
        400: '#CC0000', // primary.b2
        500: '#FF0000', // primary
        600: '#FF3333', // primary.w2
        700: '#FF8080', // primary.w5
        800: '#FFCCCC', // primary.w8
        900: '#FFF2F2', // primary.w10
        main: '#FF0000', // primary
        light: '#330000', // primary.b10
        dark: '#FFE6E6', // primary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
      secondary: {
        main: '#659AD5', // secondary.w3
        light: '#071627', // secondary.b10
        dark: '#E9F1F9', // secondary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
    },
  },
  {
    name: 'PIGMENT_GREEN_STANDARD',
    palette: {
      primary: {
        50: '#01200A', // tertiary.b10
        100: '#01300F', // tertiary.b8
        200: '#014014', // tertiary.b6
        300: '#02601E', // tertiary.b4
        400: '#028028', // tertiary.b2
        500: '#03A032', // tertiary
        600: '#35B35B', // tertiary.w2
        700: '#81D099', // tertiary.w5
        800: '#CDECD6', // tertiary.w8
        900: '#F2FAF5', // tertiary.w10
        main: '#03A032', // tertiary
        light: '#01200A', // tertiary.b10
        dark: '#E6F6EB', // tertiary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
      secondary: {
        main: '#FF4D4D', // primary.w3
        light: '#330000', // primary.b10
        dark: '#FFE6E6', // primary.w9
        contrastText: '#000000', // based on YIQ contrast
      },
    },
  },
  */
];

export { DarkThemeColors };
